module.exports = __webpack_public_path__ + "img/Asset 1.fbf86830.png";